import { Dispatch } from 'redux';
import { ResourceApi } from '../../resource/Resource';
import { OPTIMIZELY_RESOURCE } from '../resourceNames';
import { ReduxAction } from '../actions';
import {
  OptimizelyResource,
  OptimizelyResourceGetEnabledFeatures,
} from '../../resource/OptimizelyResource/types';

export const retrieveOptimizelyEnabledFeatures = (userId: string) => (
  dispatch: Dispatch<ReduxAction>
): void => {
  ResourceApi.lookup<OptimizelyResource, OptimizelyResourceGetEnabledFeatures>(
    OPTIMIZELY_RESOURCE,
    'getEnabledFeatures',
    {
      userId,
    }
  ).then(
    (features): ReduxAction => {
      return dispatch({
        type: 'GET_ENABLED_OPTIMIZELY_FEATURES_SUCCESS',
        features,
      });
    }
  );
};
